import { useEffect, useState } from 'react';
import { useNotification } from 'src/hooks/useNotification';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { useDeleteUserMutation } from 'src/services/usersService';
import { Button } from 'src/components/ui/button';
import type { User } from 'src/services/usersService';
import { useLoaderWhile } from 'src/hooks/useLoaderWhile';

export const DeleteUserPopup = ({
  user,
  disabled = false,
}: {
  user: Pick<User, 'id' | 'first_name' | 'last_name'>;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const notification = useNotification();
  const [deleteUser, { isSuccess: isSuccessDeleteUser, isLoading: isLoadingDeleteUser }] =
    useDeleteUserMutation();

  const onDeleteUserClick = () => {
    deleteUser({ userId: user.id });
  };

  useEffect(() => {
    if (isSuccessDeleteUser) {
      notification.success(`User ${user.first_name} ${user.last_name} Deleted.`);
      setOpen(false);
    }
  }, [isSuccessDeleteUser]);

  useLoaderWhile(isLoadingDeleteUser);

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger
        disabled={disabled}
        asChild
        className={clsx(disabled && 'pointer-events-none opacity-50', 'outline-0 cursor-pointer')}
      >
        <button className={'user-settings-button red'}>Delete</button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete user</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <p className="text-base	font-medium">
            Are you sure you want to delete this user irretrievably?
          </p>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="pill-outline-dark" size="pill" style={{ width: 'auto' }}>
              Cancel
            </Button>
          </DialogClose>
          <Button
            variant="pill-outline-red"
            size="pill"
            style={{ width: 'auto' }}
            onClick={onDeleteUserClick}
          >
            Yes, delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
